/**
 * 架构管理
 */
import React from 'react';
import PropTypes from 'prop-types';
import { XTabNav } from '@/components/xqxc_ui';
import styles from './index.module.scss';
import Dept from '../dept';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { connect } from 'react-redux';

class Detail extends React.Component {

    state = {
        tab: [
            { id: 1, label: '部门信息' },
        ],
        curTabID: 1,  // 当前显示的Tab页ID
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }

    // Tab页切换
    _tabChangeHandle = (tabID) => {
        this.setState({ curTabID: tabID });
    }

    // 渲染内容
    _renderContent = () => {
        const { curTabID } = this.state;
        switch (curTabID) {
            case 1:
                return (<Dept history={this.props.history} />);
            default:
                return (<Dept history={this.props.history} />);
        }
    }

    render() {
        return (
            <div className={styles.flexBoxContainer}>
                <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} />
                {this._renderContent()}
            </div>
        );
    }
}

Detail.propTypes = {
    history: PropTypes.object, // router history
    match: PropTypes.object, // router match
    setBreadcrumbPaths: PropTypes.func,
};

export default connect(null, { setBreadcrumbPaths })(Detail);